module.exports = __webpack_public_path__ + "img/Group 3125.2334cd9b.png";